import React, { HTMLAttributes, ReactNode } from 'react';

import { handleNodes } from './functions';
import parse from './libraries/parse';
import { Processor } from './types';

interface Html2ReactProps {
  isRoot?: boolean;
  processors?: Processor[];
  children?: ReactNode | string;
  innerProps?: HTMLAttributes<HTMLDivElement>;
}

const Html2React: React.FC<Html2ReactProps> = ({ isRoot = true, processors, children, innerProps }) => {
  if (!children) {
    return <></>;
  }
  if (typeof children !== 'string') {
    return children;
  }

  const _processors = (processors ?? []).sort((a, b) => (a.priority || 10) - (b.priority || 10));

  const nodes = handleNodes({
    nodes: parse(children),
    processors: _processors
  });

  return isRoot ? (
    <div className="editor-styles-wrapper">
      <div {...innerProps}>{nodes}</div>
    </div>
  ) : (
    nodes
  );
};

export default Html2React;
